import routes from "routes/routes";
import apiInstance from "services/api/api";
import IRestaurant from "shared/interfaces/Restaurant.interface";

export default (restaurantId: string): Promise<IRestaurant> =>
  apiInstance
    .get(`${routes.restaurants.path}/${restaurantId}`)
    .then((res) => res.data.data);
